import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import { HeadingSubtitle } from '../../components/Heading';
import Paragraph from '../../components/Paragraph/Paragraph';
import themeColors from '../../assets/styles/themeColors';
import { useMenu } from '../../hooks/useMenu';
import { selectSettings } from '../../store/selectors/settingsSelectors';
import EmploymentStatusForm from '../../components/Forms/EmploymentStatusForm';

const EmploymentStatus = ({ applicantType, onModalClose }) => {
  const { t } = useTranslation();
  const { activeMenu, activeItem } = useMenu();
  const settings = useSelector(selectSettings);
  const { BrokerName } = settings;
  const formId = 'employment_form';
  const [eventType, setEventType] = useState(null);
  // const { backStep } = useGtmStepTracker({
  //   currentPath: 'Employment Information',
  //   previousPath: activeItem?.previousPath || '',
  // });

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeItem={activeItem}
      previousPath={activeItem.previousPath}
      formId={formId}
      setEventType={setEventType}
    >
      <Helmet>
        <title>
          {t('titleTagDob', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <HeadingSubtitle color={themeColors.colorTextSecondary} mb={12}>
        {t('titleTagEmploymentStatus')}
      </HeadingSubtitle>
      <Paragraph mb={32} color={themeColors.colorTextXLLight}>
        {t('secureEmploymentStatus.title')}
      </Paragraph>
      <EmploymentStatusForm
        nextPath={activeItem?.nextPath}
        applicantType={applicantType}
        onModalClose={onModalClose}
        eventType={eventType}
        setEventType={setEventType}
        formId={formId}
      />
    </OnBoardingContainer>
  );
};

EmploymentStatus.propTypes = {
  applicantType: PropTypes.string,
  onModalClose: PropTypes.func,
};

export default EmploymentStatus;
